import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Breadcrumb from '../common/Breadcrumb';
import BreadcrumbItem from '../common/BreadcrumbItem';
import TrackedButtonLink from "../common/TrackedButtonLink";
import TrackedAnchor from "../common/TrackedAnchor";
import VideoLeftTextRight from '../components/page/VideoLeftTextRight';
import YouTubeVideo from '../components/page/YouTubeVideo';
import HeaderDetailText from '../components/page/HeaderDetailText';
import HeroStatic from "../components/page/HeroStatic";
import MediaLeftComponentsRight from "../components/page/MediaLeftComponentsRight";
import TestimonialCarousel from "../components/page/TestimonialCarousel";
import Feature from '../common/Feature';
import PropTypes from "prop-types";
import Testimonial from "../category/common/Testimonial";
import VideoPlayer from "../components/VideoPlayer";

const heroImg = require('../../resources/img/hero/SentrySafe_FP_Safe_Banner.png');
const heroImgMobile = require('../../resources/img/hero/SentrySafe_FP_Safe_Banner_750w.jpg');
const featuresImg = require('../../resources/img/model-serial-number/firesafes-w-shadow.png');
const fireProtectionIcon = require('../../resources/img/icons/Fire_Icon_Outline.png');
const waterProtectionIcon = require('../../resources/img/icons/Water_Icon_Outline.png');
const featureImgMetalHandle = require('../../resources/img/features/metal-handle.png');
const featureAutoSteelBolts = require('../../resources/img/features/snapback-bolts.png');
const featureImgElectronicLock = require('../../resources/img/features/electronic-lock.png');
const featureImgLithiumBatteries = require('../../resources/img/features/lithium-battery.png');
const testimonialImg1 = require('../../resources/img/callouts/fire-testimonial-1.jpg');
const testimonialImg2 = require('../../resources/img/callouts/fire-testimonial-2.jpg');
const testimonialImg3 = require('../../resources/img/callouts/fire-testimonial-3.jpg');

class FireAndWaterSafes extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const heroData = {
            imgSrc: heroImg,
            imgSrcMobile: heroImgMobile,
            imgAlt: "SentrySafe fireproof safe surrounded by composited fire and flames",
            title: "Best-in-Class Protection from Fires, Floods and Forced Entries",
            body: `<p>Introducing our newest line of fireproof safes – with the trusted security of Master Lock built in.</p>`,
            ctaUrl: "/products?models=FP082C,FPW082C,FPW082E,FPW082ES,FPW082FS,FPW082HSB,FPW082HTC,FPW082K,FPW082KS,FPW082KSB",
            ctaText: "View Safes"
        };

        const videoTextData = {
            videoUrl: 'https://fbinsecurity.widen.net/view/video/bcrhoi0sv7/',
            titleText: "Master Lock Security Built In",
            descriptionText: `<p>As the only safes designed with Master Lock advanced security features, our new line of fireproof safes stands up to physical attacks and lock manipulation.</p>`
        };

        const headerDetail = [
            {
                headerTxt: "Best-In-Class Fire Protection",
                detailTxt: `Our safes are UL Classified fire resistant for 1 Hour in temperatures up to 1700˚F – giving you best-in-class fire protection. And, if you happen to endure a fire that damages your safe, we’ll send you a replacement safe, free of charge.`,
                iconImage: fireProtectionIcon
            },
            {
                headerTxt: "Waterproof For up to 24 Hours",
                detailTxt: "In addition to superior fire protection, our next generation of fireproof safes can also protect your valuables from water damage. Select models provide ETL Verified water protection for up to 24 hours.",
                iconImage: waterProtectionIcon
            },
        ];

        const features = {
            title: "Thoughtful, Bold Innovation",
            body: "Our fireproof safes are built with user-driven enhancements that set us apart from the competition.",
            imgSrc: featuresImg,
            imgAlt: "Product image of a firesafe",
            list: [
                {
                    title: 'Metal Handle',
                    body: 'Integrated handle provides secure, yet simple access',
                    imgSrc: featureImgMetalHandle
                },
                {
                    title: 'Automatic Steel Bolts',
                    body: 'Three large 1-inch bolts provide audible confirmation when locking your safe',
                    imgSrc: featureAutoSteelBolts
                },
                {
                    title: 'Motor-Driven Electronic Lock',
                    body: 'Protects digital safes against physical attacks',
                    imgSrc: featureImgElectronicLock
                },
                {
                    title: 'Lithium Batteries',
                    body: 'Provide extended battery life',
                    imgSrc: featureImgLithiumBatteries
                }
            ]
        };

        const generateFeatureList = (features) => {
            if (Array.isArray(features.list)) {
                return features.list.map((feature, index) => {
                    return (<Feature
                        title={feature.title}
                        description={feature.body}
                        image={feature.imgSrc}
                        direction="inline"
                        rounded={true}
                        key={`feature-${index + 1}`}
                    />);
                })
            }
        }

        const featureList = generateFeatureList(features);

        const testimonials = [
            {
                imgSrc1: testimonialImg1,
                alt1: "Fire",
                quote: "We had a SentrySafe that survived the Paradise, CA wildfire. We found it 3 weeks later in the ashes of our home. We pulled out our unscathed belongings, including paper documents, pictures, and old coins. Just to put into perspective, our car melted into the concrete of our garage. There was nothing left of our house or belongings, other than our SentrySafe.",
                submitted: "Tracy L.",
                readLink: undefined,
                link: undefined,
            },
            {
                imgSrc1: testimonialImg2,
                alt1: "Fire",
                quote: "My father's home in Punta Gorda, Florida burnt completely to the ground. His home along with 6 others lost everything!!! The only thing the firemen retrieved after 2 days of burning was my father's safe. The safe was on the second floor and was found under the rubble the following day. I cut the safe open, and as you can see his belongings were safe.",
                submitted: "Marshall E.",
                readLink: undefined,
                link: undefined,
            },
            {
                imgSrc1: testimonialImg3,
                alt1: "Fire",
                quote: "I was finally able to recover my safe after a devastating house fire. Even though it was not rated for water protection the contents came out relatively dry despite the flooding from putting the fire out and months of being buried in wet debris from the months of rain since the fire.  As soon as I can afford I will have a large water rated SentrySafe. Thanks for securing my irreplaceable  items.  I will never trust anyone but SentrySafe to protect my valuables. The safe stood the test of fire and water.",
                submitted: "Michael M.",
                readLink: undefined,
                link: undefined,
            }
        ]

        return (
            <div className="container">
                <Helmet>
                    <title>New Fireproof Safes &#124; SentrySafe.com</title>
                    <meta name="description"
                        content="Our new fireproof safes offer best-in-class protection from fires, floods and forced entries." />
                </Helmet>

                {/*<Breadcrumb>*/}
                {/*    <BreadcrumbItem label="Learn" />*/}
                {/*    <BreadcrumbItem label="Fire And Water Safes" />*/}
                {/*</Breadcrumb>*/}

                <main id="content">
                    <HeroStatic data={heroData} />

                    <section className="row py-3">
                        <VideoLeftTextRight data={videoTextData} />
                    </section>

                    <section className="bg-gray pt-5">
                        <HeaderDetailText data={headerDetail} />
                    </section>

                    <section className="row d-flex justify-content-center bg-gray pb-5">
                        <div className="col md-8 p-4 mx-auto">
                            <div className="text-center mb-5">
                                <TrackedAnchor
                                    to="https://www.masterlock.com/insights/5-things-you-need-to-know-about-your-safes-fire-rating"
                                    target="_blank"
                                    rel="noopener"
                                    className="">
                                    Learn more about Fire and Water Protection
                                </TrackedAnchor>
                            </div>
                            <div className="ratio ratio-16x9">
                                {/*<VideoPlayer*/}
                                {/*    url="https://fbinsecurity.widen.net/content/d42a9mihyl/original/SS_FP-FPW_Fire-Edu_53sec_2023.mp4" />*/}
                                <VideoPlayer url="https://fbinsecurity.widen.net/view/video/d42a9mihyl/" />
                            </div>
                        </div>
                    </section>

                    <section>
                        <MediaLeftComponentsRight data={features}>
                            {featureList}
                            <TrackedButtonLink className="btn-primary"
                                to="/products?models=FP082C,FPW082C,FPW082E,FPW082ES,FPW082FS,FPW082HSB,FPW082HTC,FPW082K,FPW082KS,FPW082KSB">View
                                Our New Safes</TrackedButtonLink>
                        </MediaLeftComponentsRight>
                    </section>

                    <section className="row d-flex justify-content-center py-5 bg-gray">
                        <div className="col md-8 p-4 mx-auto">
                            <VideoPlayer
                                url="https://fbinsecurity.widen.net/view/video/vidzo0vzkp/" />
                        </div>
                    </section>

                    <section className="mb-4">
                        <TestimonialCarousel data={testimonials} />
                    </section>
                </main>
            </div>
        );
    }
}

export default FireAndWaterSafes;




// WEBPACK FOOTER //
// ./src/pages/learn/FireAndWaterSafes.js